import { MainColor } from '../../palette';

export const getChipThemeConfig = () => {
  return {
    baseChip: {
      notSelected: {
        defaultState: {
          color: 'coolGrey60' satisfies MainColor as MainColor,
          backgroundColor: 'coolGrey10' satisfies MainColor as MainColor,
        },
        hover: {
          backgroundColor: 'coolGrey20' satisfies MainColor as MainColor,
          color: 'coolGrey60' satisfies MainColor as MainColor,
        },
        active: {
          backgroundColor: 'navy10' satisfies MainColor as MainColor,
          color: 'coolGrey60' satisfies MainColor as MainColor,
        },
        focus: {
          outlineColor: 'navy40' satisfies MainColor as MainColor,
          backgroundColor: 'coolGrey10' satisfies MainColor as MainColor,
          color: 'coolGrey60' satisfies MainColor as MainColor,
        },
        readOnly: {
          borderColor: 'coolGrey30' satisfies MainColor satisfies MainColor as MainColor,
        },
      },
      selected: {
        defaultState: {
          color: 'navy50' satisfies MainColor as MainColor,
          backgroundColor: 'navy10' satisfies MainColor as MainColor,
        },
        hover: {
          backgroundColor: 'navy10' satisfies MainColor as MainColor,
          color: 'navy60' satisfies MainColor as MainColor,
        },
        active: {
          backgroundColor: 'navy20' satisfies MainColor as MainColor,
          color: 'navy60' satisfies MainColor as MainColor,
        },
        focus: {
          outlineColor: 'navy40' satisfies MainColor as MainColor,
          backgroundColor: 'navy10' satisfies MainColor as MainColor,
          color: 'navy50' satisfies MainColor as MainColor,
        },
      },
      readonly: {
        defaultState: {
          color: 'coolGrey50' satisfies MainColor as MainColor,
          backgroundColor: 'coolGrey20' satisfies MainColor as MainColor,
        },
      },
    },
    filterChip: {
      indicator: {
        backgroundColor: 'forest10' satisfies MainColor as MainColor,
        color: 'forest50' satisfies MainColor as MainColor,
      },
      notSelected: {
        defaultState: {
          color: 'coolGrey60' satisfies MainColor as MainColor,
          backgroundColor: 'coolGrey10' satisfies MainColor as MainColor,
        },
        hover: {
          backgroundColor: 'coolGrey20' satisfies MainColor as MainColor,
          color: 'coolGrey60' satisfies MainColor as MainColor,
        },
        active: {
          backgroundColor: 'navy20' satisfies MainColor as MainColor,
          color: 'coolGrey60' satisfies MainColor as MainColor,
        },
        focusVisible: {
          backgroundColor: 'navy10' satisfies MainColor as MainColor,
          color: 'coolGrey60' satisfies MainColor as MainColor,
        },
        focus: {
          outlineColor: 'navy40' satisfies MainColor as MainColor,
          backgroundColor: 'coolGrey10' satisfies MainColor as MainColor,
          color: 'coolGrey60' satisfies MainColor as MainColor,
        },
      },
      selected: {
        defaultState: {
          color: 'navy50' satisfies MainColor as MainColor,
          backgroundColor: 'navy10' satisfies MainColor as MainColor,
        },
        hover: {
          backgroundColor: 'navy10' satisfies MainColor as MainColor,
          color: 'navy60' satisfies MainColor as MainColor,
        },
        active: {
          backgroundColor: 'navy20' satisfies MainColor as MainColor,
          color: 'navy60' satisfies MainColor as MainColor,
        },
        focusVisible: {
          backgroundColor: 'navy10' satisfies MainColor as MainColor,
          color: 'navy50' satisfies MainColor as MainColor,
        },
        focus: {
          outlineColor: 'navy40' satisfies MainColor as MainColor,
          backgroundColor: 'navy10' satisfies MainColor as MainColor,
          color: 'navy50' satisfies MainColor as MainColor,
        },
      },
    },
    dateChip: {
      notSelected: {
        defaultState: {
          color: 'coolGrey60' satisfies MainColor as MainColor,
          backgroundColor: 'coolGrey10' satisfies MainColor as MainColor,
        },
        hover: {
          backgroundColor: 'coolGrey20' satisfies MainColor as MainColor,
          color: 'coolGrey60' satisfies MainColor as MainColor,
        },
        active: {
          backgroundColor: 'navy20' satisfies MainColor as MainColor,
          color: 'coolGrey60' satisfies MainColor as MainColor,
        },
        focusVisible: {
          backgroundColor: 'navy10' satisfies MainColor as MainColor,
          color: 'coolGrey60' satisfies MainColor as MainColor,
        },
        focus: {
          outlineColor: 'navy40' satisfies MainColor as MainColor,
          backgroundColor: 'coolGrey10' satisfies MainColor as MainColor,
          color: 'coolGrey60' satisfies MainColor as MainColor,
        },
      },
      selected: {
        defaultState: {
          color: 'navy50' satisfies MainColor as MainColor,
          backgroundColor: 'navy10' satisfies MainColor as MainColor,
        },
        hover: {
          backgroundColor: 'navy10' satisfies MainColor as MainColor,
          color: 'navy60' satisfies MainColor as MainColor,
        },
        active: {
          backgroundColor: 'navy20' satisfies MainColor as MainColor,
          color: 'navy60' satisfies MainColor as MainColor,
        },
        focusVisible: {
          backgroundColor: 'navy10' satisfies MainColor as MainColor,
          color: 'navy50' satisfies MainColor as MainColor,
        },
        focus: {
          outlineColor: 'navy40' satisfies MainColor as MainColor,
          backgroundColor: 'navy10' satisfies MainColor as MainColor,
          color: 'navy50' satisfies MainColor as MainColor,
        },
      },
    },
    searchChip: {
      iconColor: 'coolGrey60' satisfies MainColor as MainColor,
      unFilled: {
        defaultState: {
          color: 'coolGrey60' satisfies MainColor as MainColor,
          backgroundColor: 'white95' satisfies MainColor as MainColor,
        },
        hover: {
          backgroundColor: 'coolGrey10' satisfies MainColor as MainColor,
          color: 'coolGrey60' satisfies MainColor as MainColor,
          borderColor: 'coolGrey10' satisfies MainColor as MainColor,
        },
        active: {
          backgroundColor: 'coolGrey20' satisfies MainColor as MainColor,
          borderColor: 'coolGrey30' satisfies MainColor as MainColor,
          color: 'coolGrey60' satisfies MainColor as MainColor,
        },
        focusVisible: {
          backgroundColor: 'coolGrey10' satisfies MainColor as MainColor,
          color: 'coolGrey90' satisfies MainColor as MainColor,
          cursorColor: 'navy60' satisfies MainColor as MainColor,
        },
        focus: {
          outlineColor: 'navy40' satisfies MainColor as MainColor,
          backgroundColor: 'white95' satisfies MainColor as MainColor,
          color: 'navy60' satisfies MainColor as MainColor,
        },
      },
      filled: {
        defaultState: {
          color: 'navy95' satisfies MainColor as MainColor,
          backgroundColor: 'coolGrey10' satisfies MainColor as MainColor,
          borderColor: 'coolGrey20' satisfies MainColor as MainColor,
        },
        hover: {
          backgroundColor: 'coolGrey20' satisfies MainColor as MainColor,
          color: 'navy95' satisfies MainColor as MainColor,
        },
        active: {
          backgroundColor: 'coolGrey20' satisfies MainColor as MainColor,
          color: 'navy95' satisfies MainColor as MainColor,
        },
        focusVisible: {
          backgroundColor: 'navy10' satisfies MainColor as MainColor,
          color: 'navy95' satisfies MainColor as MainColor,
        },
        focus: {
          outlineColor: 'navy40' satisfies MainColor as MainColor,
          backgroundColor: 'coolGrey10' satisfies MainColor as MainColor,
          color: 'navy95' satisfies MainColor as MainColor,
        },
      },
      color: 'coolGrey90' satisfies MainColor as MainColor,
      placeholderColor: 'coolGrey60' satisfies MainColor as MainColor,
      backgroundColor: 'coolGrey10' satisfies MainColor as MainColor,
      focus: {
        outlineColor: 'navy40' satisfies MainColor as MainColor,
        backgroundColor: 'navy10' satisfies MainColor as MainColor,
        color: 'navy50' satisfies MainColor as MainColor,
      },
    },
  };
};

export type ChipThemeConfig = ReturnType<typeof getChipThemeConfig>;
